export enum MetricLengthUnit {
  Millimeter = 'mm',
  Centimeter = 'cm',
  Meter = 'm',
  Kilometer = 'km',
}

export enum ImperialLengthUnit {
  Inch = 'in',
  Foot = 'ft',
  Yard = 'yd',
  Mile = 'mi',
}

export type LengthUnit = MetricLengthUnit | ImperialLengthUnit;
